<template>
  <div>
    视频录像
  </div>
</template>

<script>
export default{
  data(){
    return {

    }
  },
  methods: {

  }
};
</script>

<style lang="less" scoped>
</style>